import React from "react";
import {
  $fontWeightBold,
  $fontSize
} from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";

const PageHeading = styled(Text)`
  color: #040222;
  font-weight: ${$fontWeightBold};
  line-height: 19px
  text-align: left;
  font-size: ${$fontSize.small};
  margin-bottom: ${props =>
    props && props.marginBottom ? props.marginBottom : "1rem"};

  @media (min-width: 768px) {
    line-height: 24px;
    font-size: ${$fontSize.small};
    margin-bottom:${props =>
      props && props.marginBottom ? props.marginBottom : "1.5rem"};
  }
`;

interface IComponentProps {
  text: string;
  marginBottom?: string;
}
const Heading: React.FC<IComponentProps> = ({ text, marginBottom }) => {
  return <PageHeading marginBottom={marginBottom}>{text}</PageHeading>;
};

export default Heading;
